<template>
  <div
    class="accruals-config-tabs"
    :class="{ 'accruals-config-tabs--disabled': disabled }"
    :data-testid="`${testIdPrefix}__tabs`"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="accruals-config-tabs__tab"
      :class="{ 'accruals-config-tabs__tab--active': tab.id === value }"
      :disabled="disabled"
      :data-testid="`${testIdPrefix}__tab--${tab.id}`"
      @click="$emit('input', tab.id)"
    >
      <img
        v-if="tab.icon"
        :src="tab.icon"
        alt=""
        class="accruals-config-tabs__icon"
        :data-testid="`${testIdPrefix}__tab-icon--${tab.id}`"
      />
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
import { ACCRUALS_CONFIG_TAB_ITEMS } from '../accrualsConfigurationConstants';

export default {
  name: 'AccrualsConfigurationTabs',
  props: {
    value: { type: String, required: true },
    tabs: { type: Array, default: () => ACCRUALS_CONFIG_TAB_ITEMS },
    disabled: { type: Boolean, default: false },
    testIdPrefix: { type: String, default: 'accruals-configuration-page' },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsConfigurationTabs.scss';
</style>
